import { PagesT } from '@global/types.ts';
import pages from '@redux/pages.ts';

import I from '../types.ts';

const getNav: I['getNav'] = function () {
    return pages.filter(
        (page) => (page as PagesT).parentName === 'public' || page.name === 'auth',
    ) as PagesT[];
};

export default getNav;
